<template>
    <vue-excel-editor v-model="jsondata">
        <vue-excel-column field="user"   label="User ID"       type="string" width="80px" />
        <vue-excel-column field="name"   label="Name"          type="string" width="150px" />
 
    </vue-excel-editor>
</template>

<script>


export default {
    data() {
        let jsondata = {user: "od", name : "olle"}

        return {
           jsondata
        }


    },

    methods: {
       


    },



    mounted() {

    }
}


</script>